import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIkonPassivreminder({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 56.2 90.6"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M51.9 79.8v-12c1-10-12.8-18.8-14.1-19.6-1.1-.9-2.3-2.2-2.2-3.4.1-1.2 1.5-2.1 1.9-2.3 7.6-3 11.6-10.5 13.3-14.7.8-2 1.2-4.1 1.2-6.3V10.7c2.4-.5 4.2-2.7 4.2-5.3S53.8 0 50.8 0H5.4C2.4 0 0 2.4 0 5.4s1.8 4.8 4.2 5.3v10.7c0 2.2.4 4.3 1.2 6.3 1.7 4.2 5.6 11.7 13.2 14.7 0 0 1.9 1 2 2.4.1 1.2-1.1 2.5-2.2 3.4-1.4.9-15.2 9.6-14.1 19.6v12.1C2 80.5.2 82.6.2 85.1s2.4 5.4 5.4 5.4h45.3c3 0 5.4-2.4 5.4-5.4s-1.9-4.9-4.4-5.3ZM3 5.4C3 4.1 4.1 3 5.4 3h45.3c1.3 0 2.4 1.1 2.4 2.4S52 7.8 50.7 7.8H5.4C4.1 7.8 3 6.7 3 5.4Zm17 45.3s.1 0 .2-.1c2.5-2 3.6-4.1 3.4-6.2-.3-3-3.3-4.6-3.8-4.8-6.6-2.6-10.1-9.3-11.6-13-.6-1.6-1-3.3-1-5.1V10.9h41.7v10.6c0 1.8-.3 3.5-1 5.1-1.5 3.7-5 10.4-11.7 13.1-.3.2-3.3 1.7-3.7 4.7-.2 2.1.9 4.2 3.4 6.2 0 0 .1 0 .2.1.1 0 13.7 8.3 12.8 16.8v12.2H7.2V67.5C6.3 59 19.8 50.7 20 50.7Zm30.9 36.9H5.5c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4h45.3c1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4Z" />
        </svg>
    )
}
SvgIkonPassivreminder.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIkonPassivreminder
